<!-- <div class="loader" *ngIf="loader"></div> -->

<header class="clearfix" role="banner">
  <div class="mid_container" role="navigation">
    <div class="mid_container_inner">
      <div class="logo">
        <img
          alt="ABA Logo"
          src="assets/images/logo-aba.png"
          class="img-responsive"
        />
      </div>
    </div>
    <div class="mid_container_inner">
      <div class="demo_link">
        <a
          href="https://content.aba.com/bankexec/quicktour/briefing/index.html"
          target="_blank"
          class="help_links"
          >Click Here to Watch Demo</a
        >
      </div>
    </div>
  </div>
  <div class="nav2 clearfix">
    <div class="mid_container">
      <div class="mid_container_inner">
        <div class="logo_text">
          <h1>Welcome to BankExec®</h1>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="header_banner" role="banner"></div>
<div class="login_wraper" role="main">
  <section>
    <div class="mid_container" role="region" aria-label="Login Section">
      <div class="mid_container_inner">
        <div class="fixed_wraper_left">
          <div class="login_section">
            <div class="container">
              <!-- Form Section -->
              <form
                class="form-horizontal"
                role="presentation"
                #courseForm="ngForm"
                (ngSubmit)="submit($event)"
                [hidden]="!showform"
              >
                <div class="form-group">
                  <div class="cols-sm-10">
                    <div class="input-group">
                      <span class="input-group-addon"
                        ><i class="fa fa-user fa" aria-hidden="true"></i
                      ></span>
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        placeholder="Enter Email Registered for this Program"
                        [(ngModel)]="email"
                        name="name"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="cols-sm-10">
                    <div class="input-group">
                      <span class="input-group-addon"
                        ><i class="fa fa-lock" aria-hidden="true"></i
                      ></span>
                      <input
                        type="password"
                        class="form-control"
                        placeholder="Enter your Password"
                        [(ngModel)]="password"
                        name="password"
                        id="sign_in_password"
                      />
                      <img
                        class="eye_img"
                        src="assets/images/eye_img.png"
                        alt="Show password"
                        (click)="revealPassword('sign_in_password')"
                        tabindex="0"
                        aria-label="Toggle Password Visibility"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <button
                    class="btn btn-primary btn-lg btn-block login-button check_valid"
                    type="submit"
                  >
                    Login
                  </button>
                </div>
                <div *ngIf="errorMsg" role="alert" class="errormsg">
                  {{ errorMsg }}
                </div>
                <!-- <div *ngIf="errorMsg" class="errormsg">
                                {{errorMsg}}
                              </div> -->

                <div class="form-group">
                  <div class="cols-sm-10">
                    <div class="input-group pull-right">
                      <div class="checkbox">
                        <label
                          ><a
                            (click)="forgotpassword($event)"
                            tabindex="0"
                            aria-label="Forgot your password?"
                          >
                            <i
                              class="fa fa-caret-left arrow_color"
                              aria-hidden="true"
                            ></i>
                            Forgot your password?</a
                          ></label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- Support Section -->
              <div
                class="flex-container fixed_wraper_right"
                aria-label="Support Section"
              >
                <h2 class="right_header">Support</h2>
                <div class="flex-container-support-links">
                  <a
                    href="https://content.aba.com/support/tools/BankExecHelp/FAQ.html?Student"
                    target="_blank"
                    class="help_links"
                    aria-label="Frequently Asked Questions"
                    tabindex="0"
                  >
                    <b>FAQs</b></a
                  >
                  <a
                    href="https://content.aba.com/support/tools/bankexecsyscheck/default.aspx"
                    target="_blank"
                    class="help_links"
                    aria-label="System Check"
                    tabindex="0"
                  >
                    <b>System Check</b></a
                  >
                  <a
                    href="https://content.aba.com/support/tools/BankExecHelp/contact.aspx"
                    target="_blank"
                    class="help_links"
                    aria-label="Get Help"
                    tabindex="0"
                  >
                    <b>GET HELP </b></a
                  >
                </div>
                <p class="support_link">Call 1-800-BANKERS</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
